<template lang="pug">
BriqInput(
  :value="value"
  @input="e => $emit('input', e)"
  :label="customField.FieldName" 
  :placeholder="customField.FieldName" 
  :name="customField.FieldCode" 
  :required="!customField.Optional"
  :help="customField.Description"
  :error="error"
  data-test-id="custom-field-input"
  )
</template>

<script>
import { validateProps } from '@v/util/propValidators.js'

export default {
  name: 'CustomFieldInput',
  props: {
    customField: {
      type: Object,
      validator: validateProps(['FieldCode', 'FieldName', 'Optional', 'Description']),
    },
    value: [String, Number],
    error: String,
  },
}
</script>
